// Takes a geocoded result and pulls out information we look for.
export class GoogleMapsGeocode {
    geocode: google.maps.GeocoderResult;
    geocodeCity: string;
    geocodeState: string;

    constructor(geocode: google.maps.GeocoderResult) {
        this.geocode = geocode;
    }

    // given a geocoded results, this will give a "nice" version of the city
    getGeocodeCity(): string {
        if (this.geocodeCity) {
            return this.geocodeCity;
        }
        this.geocodeCity = this.getComponentLongName("locality");
        return this.geocodeCity;
    }

    // given a geocoded results, this will give a "nice" version of the city
    getGeocodeState(): string {
        if (this.geocodeState) {
            return this.geocodeState;
        }
        this.geocodeState = this.getComponentShortName("administrative_area_level_1");
        return this.geocodeState;
    }

    // given a geocoded results, this will give a "nice" version of the city
    private getComponentShortName(componentType: string): string {
        const component = this.getComponent(componentType);
        if (component) {
            return component.short_name;
        }
    }

    // given a geocoded results, this will give a "nice" version of the city
    private getComponentLongName(componentType: string): string {
        const component = this.getComponent(componentType);
        if (component) {
            return component.long_name;
        }
    }

    // given a geocoded results, this will give a "nice" version of the city
    getComponent(componentType: string): google.maps.GeocoderAddressComponent {
        const arrAddress = this.geocode.address_components;

        for (var idx = 0; idx < arrAddress.length; ++idx) {
            var address_component = arrAddress[idx];
            if (address_component.types[0] === componentType) {
                return address_component;
            }
        }

        return null;
    }

    // given a geocoded results, this will give a "nice" version of the city
    getGeocodeCityState(): string {
        const city = this.getGeocodeCity();
        const state = this.getGeocodeState();
        if (city && state) {
            return city + ", " + state;
        } else {
            return this.geocode.formatted_address;
        }
    }
}
